export const COOKIE_INVITER_ID = 'inviterId'

export const ONE_YEAR_EXPIRE_TIME = 31536000000
